import React, { useState, useRef } from 'react';
import AdminLayout from '../../components/AdminLayout';
import api from '../../api';

export default function Import() {
  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [dragOver, setDragOver] = useState(false);
  const fileRef = useRef();

  const handleFile = (f) => {
    if (!f || !f.name.endsWith('.csv')) { setError('Please select a CSV file'); return; }
    setFile(f); setError(''); setResult(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) return;
    setLoading(true);
    setError('');
    try {
      const fd = new FormData();
      fd.append('file', file);
      const { data } = await api.post('/import/clients', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setResult(data);
      setFile(null);
    } catch (err) {
      setError(err.response?.data?.error || 'Import failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <h1 className="page-title" style={{ marginBottom: '8px' }}>Import Clients</h1>
      <p className="text-muted text-sm" style={{ marginBottom: '32px' }}>
        Bulk upload clients from a CSV file (e.g. Booksy export)
      </p>

      <div style={{ maxWidth: '640px' }}>
        {/* Format info */}
        <div className="card" style={{ marginBottom: '24px', borderColor: 'rgba(245,158,11,0.3)', background: 'rgba(245,158,11,0.05)' }}>
          <div style={{ fontWeight: 700, fontSize: '14px', color: '#f59e0b', marginBottom: '10px' }}>Expected CSV Format</div>
          <div style={{ fontFamily: 'monospace', fontSize: '13px', color: '#9ca3af', background: '#0f0f1a', padding: '12px', borderRadius: '8px', border: '1px solid #2d2d44' }}>
            name,phone,email,notes<br/>
            John Doe,5615550100,john@example.com,prefers low fade<br/>
            Jane Smith,5615550101,jane@example.com,
          </div>
          <p style={{ color: '#9ca3af', fontSize: '13px', marginTop: '10px' }}>
            Column names are case-insensitive. Only <strong>name</strong> is required.
            Duplicate emails/phones are skipped automatically.
          </p>
        </div>

        {/* Upload area */}
        <div className="card">
          <form onSubmit={handleSubmit}>
            <div
              onDragOver={e => { e.preventDefault(); setDragOver(true); }}
              onDragLeave={() => setDragOver(false)}
              onDrop={e => { e.preventDefault(); setDragOver(false); handleFile(e.dataTransfer.files[0]); }}
              onClick={() => fileRef.current?.click()}
              style={{
                border: `2px dashed ${dragOver ? '#f59e0b' : file ? '#10b981' : '#2d2d44'}`,
                borderRadius: '12px',
                padding: '48px 24px',
                textAlign: 'center',
                cursor: 'pointer',
                transition: 'all 0.2s',
                background: dragOver ? 'rgba(245,158,11,0.05)' : file ? 'rgba(16,185,129,0.05)' : 'transparent',
                marginBottom: '20px',
              }}>
              <input ref={fileRef} type="file" accept=".csv" style={{ display: 'none' }}
                onChange={e => handleFile(e.target.files[0])} />
              <div style={{ fontSize: '40px', marginBottom: '12px', color: file ? '#10b981' : '#6b7280' }}>{file ? '✓' : '+'}</div>
              {file ? (
                <div>
                  <div style={{ fontWeight: 700, color: '#10b981' }}>{file.name}</div>
                  <div style={{ color: '#9ca3af', fontSize: '13px', marginTop: '4px' }}>{(file.size / 1024).toFixed(1)} KB</div>
                </div>
              ) : (
                <div>
                  <div style={{ fontWeight: 700, marginBottom: '4px' }}>Drop your CSV here</div>
                  <div style={{ color: '#9ca3af', fontSize: '14px' }}>or click to browse</div>
                </div>
              )}
            </div>

            {error && (
              <div style={{ color: '#ef4444', background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', padding: '12px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px' }}>
                {error}
              </div>
            )}

            <button type="submit" className="btn btn-primary w-full" disabled={!file || loading} style={{ padding: '14px', fontSize: '16px' }}>
              {loading ? 'Importing...' : 'Import Clients'}
            </button>
          </form>

          {result && (
            <div style={{ marginTop: '20px', background: 'rgba(16,185,129,0.1)', border: '1px solid rgba(16,185,129,0.3)', borderRadius: '10px', padding: '20px', textAlign: 'center' }}>
              <div style={{ fontSize: '32px', marginBottom: '8px', color: '#10b981' }}>✓</div>
              <div style={{ fontWeight: 700, color: '#10b981', fontSize: '18px' }}>Import Complete</div>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '32px', marginTop: '16px' }}>
                {[
                  { label: 'Imported', value: result.imported, color: '#10b981' },
                  { label: 'Skipped', value: result.skipped, color: '#f59e0b' },
                  { label: 'Total Rows', value: result.total, color: '#9ca3af' },
                ].map(s => (
                  <div key={s.label} style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: '28px', fontWeight: 800, color: s.color }}>{s.value}</div>
                    <div style={{ fontSize: '12px', color: '#9ca3af' }}>{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
